module.exports = __webpack_public_path__ + "static/media/11_l_lustra1_13.39_1.57.36e73049.png";